import React from 'react';

import { Checkbox } from '@material-ui/core';
import styled from 'styled-components';
import { Divider1, StyledBox, StyledGrid, StyledIconButton, StyledPaper, StyledTooltip } from 'styles/common';

import { QUESTION_ORDER_ACTIONS } from 'constants/ProjectConstants';
import { generateKey } from 'constants/helper';
import { UpArrowIcon2, DownArrowIcon2, DeleteIcon3, CheckIcon2, EmptyCheckbox, PlusIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Typography12 } from 'uiToolkit/Typography';

const TemplateQuestionAction = ({
  handleQuestionDataChange,
  handleRemoveQuestion,
  handleChangeOrder,
  handleAddQuestionClick,
  questionIndex,
  isRequired,
  isLastQuestion,
  canOptional = true,
  disabled = false,
  isAllowedAddQuestion = true,
  addQuestionTooltip = '',
  isAllowEdit = true,
}) => (
  <ActionsContainer border={theme.palette.borders.blue}>
    <StyledGrid container padding="0.75rem 0.5rem">
      <StyledGrid item xs={6} bottomGutter={2} topGutter={1}>
        <StyledBox
          flexcontainer
          justifycontent="center"
          alignitems="center"
          style={{
            cursor: disabled || !isAllowEdit ? 'not-allowed' : 'pointer',
          }}
        >
          <StyledTooltip title="Move up">
            <IconWrapper>
              <StyledIconButton
                onClick={() => {
                  handleChangeOrder({
                    index: questionIndex,
                    action: QUESTION_ORDER_ACTIONS.MOVE_UP,
                  });
                }}
                disabled={questionIndex === 0 || disabled || !isAllowEdit}
                style={{
                  opacity: disabled || !isAllowEdit ? 0.5 : 1,
                }}
              >
                <UpArrowIcon2
                  color={questionIndex === 0 || disabled ? theme.palette.background.lightGrey3 : 'primary'}
                  size="fixed10px"
                  containerSize="fixed24px"
                  circularOutline
                />
              </StyledIconButton>
            </IconWrapper>
          </StyledTooltip>
        </StyledBox>
      </StyledGrid>
      <StyledGrid item xs={6} bottomGutter={2} topGutter={1}>
        <StyledBox
          flexcontainer
          justifycontent="center"
          alignitems="center"
          style={{
            cursor: isLastQuestion || disabled || !isAllowEdit ? 'not-allowed' : 'pointer',
          }}
        >
          <StyledTooltip title="Move down">
            <IconWrapper>
              <StyledIconButton
                onClick={() => {
                  handleChangeOrder({
                    index: questionIndex,
                    action: QUESTION_ORDER_ACTIONS.MOVE_DOWN,
                  });
                }}
                disabled={isLastQuestion || disabled || !isAllowEdit}
                style={{
                  opacity: disabled || !isAllowEdit ? 0.5 : 1,
                }}
              >
                <DownArrowIcon2
                  color={isLastQuestion || disabled ? theme.palette.background.lightGrey3 : 'primary'}
                  size="fixed10px"
                  containerSize="fixed24px"
                  circularOutline
                />
              </StyledIconButton>
            </IconWrapper>
          </StyledTooltip>
        </StyledBox>
      </StyledGrid>
      <StyledGrid item xs={6}>
        <StyledBox
          flexcontainer
          justifycontent="center"
          alignitems="center"
          style={{
            cursor: disabled || !isAllowEdit ? 'not-allowed' : 'pointer',
          }}
        >
          <StyledTooltip title="Delete">
            <IconWrapper>
              <StyledIconButton
                disabled={disabled || !isAllowEdit}
                onClick={() => handleRemoveQuestion({ index: questionIndex })}
                style={{
                  opacity: disabled || !isAllowEdit ? 0.5 : 1,
                }}
              >
                <DeleteIcon3
                  color={disabled ? theme.palette.background.lightGrey3 : 'primary'}
                  size="fixed10px"
                  containerSize="fixed24px"
                  circularOutline
                />
              </StyledIconButton>
            </IconWrapper>
          </StyledTooltip>
        </StyledBox>
      </StyledGrid>
      <StyledGrid item xs={6}>
        <StyledBox
          flexcontainer
          justifycontent="center"
          alignitems="center"
          style={{
            cursor: disabled || !isAllowedAddQuestion || !isAllowEdit ? 'not-allowed' : 'pointer',
          }}
        >
          <StyledTooltip title={addQuestionTooltip || 'Add Question'}>
            <IconWrapper>
              <StyledIconButton
                disabled={disabled || !isAllowedAddQuestion || !isAllowEdit}
                onClick={() => handleAddQuestionClick({ insertionPosition: questionIndex })}
                style={{
                  opacity: disabled || !isAllowEdit ? 0.5 : 1,
                }}
              >
                <PlusIcon
                  color={disabled || !isAllowedAddQuestion ? theme.palette.background.lightGrey3 : 'primary'}
                  size="fixed10px"
                  containerSize="fixed24px"
                  circularOutline
                />
              </StyledIconButton>
            </IconWrapper>
          </StyledTooltip>
        </StyledBox>
      </StyledGrid>
      <StyledGrid item xs={12}>
        <Divider1 topGutter={2} />
        <StyledBox flexcontainer justifycontent="center" alignitems="center">
          <Checkbox
            id={generateKey(8)}
            color={disabled || !isAllowEdit ? theme.palette.background.lightGrey3 : 'primary'}
            checked={!isRequired}
            onChange={(e) => {
              handleQuestionDataChange({
                param: 'isRequired',
                value: !e.target.checked,
                index: questionIndex,
              });
            }}
            checkedIcon={
              <CheckIcon2
                smoothEdgeOutline
                color={disabled || !isAllowEdit || !canOptional ? theme.palette.background.lightGrey3 : 'primary'}
                size="fixed10px"
                containerSize="fixed20px"
              />
            }
            icon={
              <EmptyCheckbox
                size="fixed20px"
                stroke={disabled || !isAllowEdit || !canOptional ? theme.palette.background.lightGrey3 : 'primary'}
              />
            }
            disabled={!canOptional || !isAllowEdit}
            style={{
              opacity: !canOptional || !isAllowEdit ? 0.5 : 1,
            }}
          />
          <Typography12
            display="inline"
            color={disabled || !isAllowEdit ? theme.palette.background.lightGrey3 : 'primary'}
          >
            Optional
          </Typography12>
        </StyledBox>
      </StyledGrid>
    </StyledGrid>
  </ActionsContainer>
);

export default TemplateQuestionAction;

const ActionsContainer = styled(StyledPaper)``;

const IconWrapper = styled.div``;
